export default __webpack_public_path__ + "static/media/SWT0550.34I-20671_-23131_0.58314591.jpg";